export class BaseApi {
	public accessToken: string;
}
